import type { CmsLink } from '@omnia/ui/src/lib'
import { CmsLinkComponent } from '@omnia/ui/src/lib'
import type { FC, ReactNode } from 'react'
import { useMatch, useResolvedPath } from 'react-router-dom-v7'

interface NavLinkProps {
    link: CmsLink
    onClick?: () => void
    children?: ReactNode
}

export const NavLink: FC<NavLinkProps> = ({ link, onClick, children }) => {
    const resolved = useResolvedPath(link.url)
    const match = useMatch({ path: resolved.pathname, end: false })
    const className = match && link.url !== '/' ? 'active' : undefined

    return <CmsLinkComponent link={link} className={className} onClick={onClick} children={children} />
}
